import { render, staticRenderFns } from "./WikiModal.vue?vue&type=template&id=1873b213"
import script from "./WikiModal.vue?vue&type=script&lang=js"
export * from "./WikiModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports